import { Component, OnInit } from '@angular/core';
import { RegistrationPreSorteoGna } from '../../../models/registration-pre-sorteo-gna.model';

@Component({
  selector: 'app-page-generate-selection',
  templateUrl: './page-generate-selection.component.html',
  styleUrls: ['./page-generate-selection.component.scss']
})
export class PageGenerateSelectionComponent implements OnInit {

  registrationPS: RegistrationPreSorteoGna;
  constructor() { }

  ngOnInit(): void {
  }

}
